import { render } from "./PickupRegiFormUnit.vue?vue&type=template&id=0ffc1138"
import script from "./PickupRegiFormUnit.vue?vue&type=script&lang=js"
export * from "./PickupRegiFormUnit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__